import { suffixPending, suffixFulfilled, suffixRejected } from "actions";
import { ADMIN_ACTIONS } from "../../../actions/protocols/admin";

export const getAdminInfoPending = ADMIN_ACTIONS.GET_ADMIN_DATA + suffixPending;
export const getAdminInfoFullfilled = ADMIN_ACTIONS.GET_ADMIN_DATA + suffixFulfilled;
export const getAdminInfoRejected = ADMIN_ACTIONS.GET_ADMIN_DATA + suffixRejected;


const initialState = {
    adminInfo: null,
    isLoading: false
};

const AdminReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case getAdminInfoPending:
            return { ...state, isLoading: true };
        case getAdminInfoFullfilled:
            return {
                ...state,
                adminInfo: action.payload,
                isLoading: false
            };
        case getAdminInfoRejected:
            return {
                ...state,
                adminInfo: null,
                isLoading: false
            }
        default:
            return state;
    }
};


export default AdminReducer;

export const getAdminInfoSelector = state => state.adminState.adminInfo;
export const getAdminLoadingSelector = state => state.adminState.isLoading;